import dynamic from 'next/dynamic';

const Content = dynamic(() => import('./content'), {
    ssr: true,
});
export default Content;
